import { useState, useEffect, useCallback } from "react";
import customerMessage from "../../customer_message.json";

const STORAGE_KEY_PREFIX = "ihub_customer_message_dismissed_v";
const DISMISS_EVENT = "ihub_customer_message_dismissed";

const storageKey = (version) => `${STORAGE_KEY_PREFIX}${version}`;

const readDismissed = (version) => {
  try {
    return window.localStorage.getItem(storageKey(version)) === "1";
  } catch {
    return false;
  }
};

export const useCustomerMessage = () => {
  const { version, title, message } = customerMessage;
  const hasMessage = Boolean(message?.trim());

  const [dismissed, setDismissed] = useState(() => !hasMessage || readDismissed(version));

  useEffect(() => {
    const handler = () => setDismissed(readDismissed(version));
    window.addEventListener(DISMISS_EVENT, handler);
    return () => window.removeEventListener(DISMISS_EVENT, handler);
  }, [version]);

  const dismiss = useCallback(() => {
    try {
      window.localStorage.setItem(storageKey(version), "1");
    } catch {}
    window.dispatchEvent(new Event(DISMISS_EVENT));
  }, [version]);

  return { title, message, hasMessage, isVisible: hasMessage && !dismissed, dismiss };
};
